import { Animation } from "@ionic/angular";

export interface CreateModalOptions {
  align?: ModalAlign;
  component: any;
  cssClass?: string[];
  mode?: ModalMode;
  swipeToClose?: boolean;
  componentProps?: ModalProps;
  backdropDismiss?: boolean;
  enterAnimation?: (baseEl: any, opts?: any) => Animation;
  leaveAnimation?: (baseEl: any, opts?: any) => Animation;
}

export enum ModalAlign {
  FULL, BOTTOM, CENTER
}

export enum ModalMode {
  ios = 'ios',
  android = 'md'
}

export interface ModalProps {
  [key: string]: any;
  buttons?: ModalButton[];
}

export interface ModalButton {
  label: string;
  class?: string;
  onClickPromiseAction?: () => Promise<any>;
  onClickAction?: () => void;
}